export const resultPhrases = (counter: number) => {
  if (counter <= 3) {
    return {
      title: <>Ни&nbsp;к&nbsp;селу, ни&nbsp;к&nbsp;городу</>,
      titleCopy: <>Ни&nbsp;к&nbsp;селу, ни&nbsp;к&nbsp;городу</>,
      description: <>И&nbsp;на&nbsp;вашей улице будет рекорд</>,
      text: (
        <>
          Кажется, угадывание городов с&nbsp;рекордами&nbsp;&mdash; не&nbsp;ваша
          сильная сторона. Впрочем, мы&nbsp;и&nbsp;правда живём в&nbsp;стране,
          которая умеет удивлять.
        </>
      ),
      textCopy: (
        <>
          Кажется, угадывание городов с&nbsp;рекордами&nbsp;&mdash;
          не&nbsp;самая сильная сторона вашего друга. Впрочем,
          мы&nbsp;и&nbsp;правда живём в&nbsp;стране, которая умеет удивлять.
          Попробуете проверить свои силы?
        </>
      ),
    }
  } else if (counter <= 6) {
    return {
      title: <>Самый-самый… средний результат</>,
      titleCopy: <>Самый-самый… средний результат</>,
      description: <>Вы&nbsp;правы&nbsp;&mdash; кто вообще это знает?</>,
      text: (
        <>
          Неплохо! Мы&nbsp;старались спрятать рекорды и&nbsp;повести вас
          по&nbsp;ложному следу. Но&nbsp;многие города вы&nbsp;всё&nbsp;же
          угадали.
        </>
      ),
      textCopy: (
        <>
          Мы&nbsp;старались спрятать рекорды и&nbsp;повести вашего друга
          по&nbsp;ложному следу. Но&nbsp;многие города он&nbsp;всё&nbsp;же
          угадал. Попробуете проверить свои силы и&nbsp;узнать рекорды России?
        </>
      ),
    }
  } else if (counter <= 8) {
    return {
      title: <>Идёте на&nbsp;рекорд!</>,
      titleCopy: <>Знаток глубин, но&nbsp;пока не&nbsp;глубинок</>,
      description: <>Знаток глубин, но&nbsp;пока не&nbsp;глубинок</>,
      text: (
        <>
          Отличный результат! Вы&nbsp;угадали большую часть городов. Однако
          некоторые места в&nbsp;России всё-таки вас удивили.
        </>
      ),
      textCopy: (
        <>
          Ваш друг угадал большую часть городов. Однако некоторые места
          в&nbsp;России всё-таки его удивили. Попробуете проверить свои силы
          и&nbsp;узнать рекорды России?
        </>
      ),
    }
  } else {
    return {
      title: <>Ой, забыли внести вас в&nbsp;список рекордов!</>,
      titleCopy: <>Ой, забыли внести вашего друга в&nbsp;список рекордов!</>,
      description: <></>,
      text: (
        <>
          Мы&nbsp;впечатлены. Либо вам жутко везёт, либо вы&nbsp;очень много
          знаете о&nbsp;городах нашей страны. Браво!
        </>
      ),
      textCopy: (
        <>
          Либо вашему другу жутко везёт, либо он&nbsp;очень много знает
          о&nbsp;городах нашей страны. Сможете также?
        </>
      ),
    }
  }
}
export default resultPhrases
